// The filters Crayon draws through, from its artboard: a wobble for a long
// line (a card's outline, a row's rule), a smaller one for an icon's strokes,
// and the crayon itself — a waxy grain eaten out of a fill, the way a crayon
// skips on paper. Its stylesheet names them by id; `LookDefs` mounts them.

export function CrayonDefs() {
  return (
    <defs>
      <filter
        id="crayon-wobble"
        x="-6%"
        y="-25%"
        width="112%"
        height="150%"
        colorInterpolationFilters="sRGB"
      >
        <feTurbulence
          type="fractalNoise"
          baseFrequency="0.035"
          numOctaves="2"
          seed="4"
          result="n"
        />
        <feDisplacementMap
          in="SourceGraphic"
          in2="n"
          scale="3"
          xChannelSelector="R"
          yChannelSelector="G"
        />
      </filter>
      <filter
        id="crayon-wobble-sm"
        x="-12%"
        y="-12%"
        width="124%"
        height="124%"
        colorInterpolationFilters="sRGB"
      >
        <feTurbulence type="fractalNoise" baseFrequency="0.08" numOctaves="2" seed="9" result="n" />
        <feDisplacementMap
          in="SourceGraphic"
          in2="n"
          scale="1.5"
          xChannelSelector="R"
          yChannelSelector="G"
        />
      </filter>
      <filter
        id="crayon-grain"
        x="-8%"
        y="-25%"
        width="116%"
        height="150%"
        colorInterpolationFilters="sRGB"
      >
        <feTurbulence type="fractalNoise" baseFrequency="0.95" numOctaves="2" seed="7" result="g" />
        <feColorMatrix
          in="g"
          type="matrix"
          values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  2.6 0 0 0 -0.55"
          result="m"
        />
        <feComposite in="SourceGraphic" in2="m" operator="in" result="tex" />
        <feTurbulence type="fractalNoise" baseFrequency="0.04" numOctaves="2" seed="3" result="w" />
        <feDisplacementMap in="tex" in2="w" scale="2.5" xChannelSelector="R" yChannelSelector="G" />
      </filter>
    </defs>
  );
}
